import classes from 'classnames';
import { memo, useEffect, useState } from 'react';
import styles from './Timeout.module.scss';
import {
  DEFAULT_TIMEOUT_SECONDS,
  getTimerKey,
  getInitialTimeout,
  clearTimer,
} from 'utils/timeoutUtility';
import { formatCountdown } from 'utils/date';

export type Props = {
  seconds?: number;
  onTimeout: () => void;
  className?: string;
  dataTest?: string;
  resetTimer?: boolean;
  // For multi using
  timerName?: string;
};

const Timeout = memo(
  ({
    seconds = DEFAULT_TIMEOUT_SECONDS,
    onTimeout,
    className,
    dataTest = 'timeout',
    resetTimer = false,
    timerName,
  }: Props) => {
    const [time, setTime] = useState<number>(
      () => getInitialTimeout(seconds, timerName) || seconds,
    );

    useEffect(() => {
      if (resetTimer && sessionStorage.getItem(getTimerKey(timerName)))
        clearTimer(timerName);
    }, [resetTimer, timerName]);

    useEffect(() => {
      const countdown = setInterval(() => {
        setTime((prevTime) => {
          const newTime = prevTime - 1;
          if (newTime <= 0) {
            clearInterval(countdown);
            onTimeout();
          }
          return newTime;
        });
      }, 1000);
      return () => {
        clearInterval(countdown);
      };
    }, [onTimeout]);

    return (
      <span className={classes(styles.timer, className)} data-test={dataTest}>
        {formatCountdown(time, seconds)}
      </span>
    );
  },
);

export default Timeout;
